export const AGREEMENT_ID = 'Agreement ID:';
export const COMPLETE_TEXT = 'Complete';
export const INCOMPLETE_TEXT = 'Incomplete';
export const ACTIVE = 'Active';
